"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureValidUserLanguagesInPreferences = exports.validateAndCleanUserPreferences = void 0;
const types_1 = require("@fluent-forever/types");
const R = __importStar(require("ramda"));
const PartialPreferencesSchema = types_1.UserPreferencesSchema.strict().partial();
const validateAndCleanUserPreferences = (preferences, logger) => {
    const originalValidationResult = PartialPreferencesSchema.safeParse(preferences);
    if (originalValidationResult.success) {
        return originalValidationResult;
    }
    logger === null || logger === void 0 ? void 0 : logger.error(`Found invalid preferences \n ${preferences}`);
    const issues = originalValidationResult.error.issues;
    const fieldNamesWithIgnorableIssues = getFieldNamesWithIgnorableIssues(issues);
    return fieldNamesWithIgnorableIssues.length
        ? exports.validateAndCleanUserPreferences(R.omit(fieldNamesWithIgnorableIssues, preferences))
        : originalValidationResult;
};
exports.validateAndCleanUserPreferences = validateAndCleanUserPreferences;
const ensureValidUserLanguagesInPreferences = (userPreferences) => {
    const { currentUserLanguageCode, everUsedUserLanguageCodes, } = userPreferences;
    return {
        ...userPreferences,
        everUsedUserLanguageCodes: !!currentUserLanguageCode &&
            !!everUsedUserLanguageCodes &&
            R.none((l) => l === currentUserLanguageCode, everUsedUserLanguageCodes)
            ? addUserLanguage(everUsedUserLanguageCodes, currentUserLanguageCode)
            : everUsedUserLanguageCodes,
    };
};
exports.ensureValidUserLanguagesInPreferences = ensureValidUserLanguagesInPreferences;
// === INTERNAL ===
// --- Validating preferences ---
const getFieldNamesWithIgnorableIssues = (issues) => R.flatten(issues.filter(isIgnorableZodIssue).map(getFieldNames));
const getFieldNames = (issue) => isZodUnrecognizedKeysIssue(issue) ? issue.keys : [issue.path[0].toString()];
/**
 * Function that indicates which Zod issues we can ignore and retry the validation
 * again without the fields that caused the issue.
 */
const isIgnorableZodIssue = (issue) => 
// A key is present and it shouldn't
isZodUnrecognizedKeysIssue(issue) ||
    // We check that the path has length as, if it has not, it indicates that the preferences are not an object
    // (e.g.: we have been passed a string, undefined, null...)
    (isZodInvalidTypeIssue(issue) && issue.path.length > 0);
const isZodUnrecognizedKeysIssue = (issue) => issue.code === "unrecognized_keys";
const isZodInvalidTypeIssue = (issue) => issue.code === "invalid_type";
// --- Adding languages ---
/**
 * Adds the given userLanguage to userLanguages, making sure we don't create a duplicated language.
 */
const addUserLanguage = (userLanguages, userLanguage) => R.reject((l) => l === userLanguage, userLanguages).concat([userLanguage]);
//# sourceMappingURL=user_preferences_utils.js.map